import React from 'react';

import BriefcaseIcon from '@atlaskit/icon/core/briefcase';

export const ToneProfessionalIcon = (): React.JSX.Element => (
	<BriefcaseIcon label="" color="currentColor" spacing="spacious" />
);
